import type { UmbLocalizationDictionary } from '@umbraco-cms/backoffice/localization-api';

export default {
	auth: {
		continue: 'Continue',
		validate: 'Validate',
		login: 'Login',
		email: 'E-mail',
		username: 'Username',
		password: 'Password',
		submit: 'Submit',
		required: 'Required',
		success: 'Success',
		forgottenPassword: 'Forgotten password?',
		forgottenPasswordInstruction: 'An email will be sent with a link to reset your password',
		requestPasswordResetConfirmation:
			'We sent an email with password reset instructions, if the email address matches a registered user.',
		setPasswordConfirmation: 'Your password has been updated',
		rememberMe: 'Remember me',
		error: 'Error',
		defaultError: 'An error occurred while processing your request.',
		errorInPasswordFormat:
			'The password must be at least {0} characters long and contain at least {1} special characters.',
		passwordMismatch: 'The confirmed password does not match the new password!',
		passwordMinLength: 'The password must be at least {0} characters long.',
		passwordIsBlank: 'The password cannot be blank.',
		userFailedLogin: "Oops! We couldn't log you in. Please check your credentials and try again.",
		userLockedOut: 'Your account has been locked out. Please try again later.',
		receivedErrorFromServer: 'Received an error from the server',
		resetCodeExpired: 'The link you have clicked on is invalid or has expired',
		userInviteWelcomeMessage:
			"Hello there and welcome to Umbraco! In just 1 minute you'll be good to go, we just need you to setup a password.",
		userInviteExpiredMessage:
			'Welcome to Umbraco! Unfortunately your invite has expired. Please contact your administrator and ask them to resend it.',
		newPassword: 'New password',
		confirmNewPassword: 'Confirm password',
		greeting0: 'Welcome',
		greeting1: 'Welcome',
		greeting2: 'Welcome',
		greeting3: 'Welcome',
		greeting4: 'Welcome',
		greeting5: 'Welcome',
		greeting6: 'Welcome',
		mfaTitle: 'One last step',
		mfaCodeInputHelp: 'Enter the code from your authenticator app',
		mfaText: 'You have enabled 2-factor authentication and must verify your identity.',
		mfaMultipleText: 'Please choose a 2-factor provider',
		mfaCodeInput: 'Verification code',
		mfaInvalidCode: 'Invalid code entered',
		signInWith: 'Sign in with {0}',
		returnToLogin: 'Return to login',
		localLoginDisabled: 'Unfortunately, direct login is not possible. It has been disabled by a provider.',
		friendlyGreeting: 'Hello',
		requiredEmailValidationMessage: 'Please fill in an email',
		requiredUsernameValidationMessage: 'Please fill in a username',
		requiredPasswordValidationMessage: 'Please fill in a password',
		showPassword: 'Show password',
		hidePassword: 'Hide password',
	},
} satisfies UmbLocalizationDictionary;
